import TransportDocumentEdit from "./TransportDocumentEdit.vue";
import TransportDocumentRouteLanding from "./TransportDocumentRouteLanding.vue";
import TransportDocumentView from "./TransportDocumentView.vue";

const base = "/transportdocument";

export default [
    {
        path: base + "/new/:jobUuid/:wasteItemIds",
        name: "transportdocumentnew",
        props: { new: true },
        component: TransportDocumentEdit
    },
    {
        path: base + "/:uuid",
        name: "transportdocumentroutelanding",
        props: true,
        component: TransportDocumentRouteLanding
    },
    {
        path: base + "/:uuid/preview",
        name: "transportdocumentpreview",
        props: (route: { params: any; }) => ({ ...route.params, preview: true }),
        component: TransportDocumentView
    }
]